<template>
<div class="container" style="margin: 10px auto 80px auto; padding-bottom: 80px;">	    
    <div class="row border-bottom pb-2">  
        <div class="col">
            <h3 class="display-5">
                <i class="text-danger fas" :class="{'fa-calendar-day': !$root.loading && !downloading, 'fa-circle-notch fa-spin': $root.loading || downloading}"></i> 
                Documents by Date            
                <button v-if="startDate == '00000000' && endDate == '99999999'" :disabled="$root.loading" type="button" class="float-end mt-3 btn btn-primary" v-on:click.self="dateFilterOpen()"><i class="fas fa-filter"></i> Filter documents by date</button>
                <button v-if="startDate != '00000000' && endDate != '99999999'" type="button" class="float-end mt-3 btn btn-primary" v-on:click.self="dateFilterReset()"><i class="fas fa-ban"></i> Clear date filter</button>
            </h3>
        </div>                 
    </div>
    <div v-if="!$root.loading" class="row mt-3" :class="{'downloading': downloading}">
        <div :key="y" class="col-12 mb-1 pb-2 border-bottom" v-for="(d,y) in paginatedData">
            <h3>{{d.NICE_DATE}}</h3>
            <div class="mb-1 alert alert-warning" v-if="d.ERECEIPT > 0">There are unreviewed e-Receipts for this date</div>
            <div class="row">
                <div class="col-4">
                    <div class="row m-1">
                        <div class="pl-0 col-6">e-Receipts:</div><div class="col">{{d.ERECEIPT}} <button v-on:click="getDocs('ERECEIPT', d.PROCESSED_DATE)" type="button" :disabled="d.ERECEIPT == 0" class="float-end text-white btn btn-sm btn-info">View</button></div>
                    </div>
                    <div class="row m-1">
                        <div class="pl-0 col-6">Receipts:</div>
                        <div class="col">{{parseInt(d.RECEIPTS) + parseInt(d.REVERSALS)}}
                            <div class="dropdown float-end">
                                <button :id="'receipt_'+y" :disabled="d.RECEIPTS == 0 && d.REVERSALS == 0" type="button" class="btn btn-sm btn-success dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Download
                                </button>
                                <div class="dropdown-menu" :aria-labelledby="'receipt_'+y">                                    
                                    <a class="dropdown-item" v-if="d.RECEIPTS > 0" v-on:click.prevent="getDocs('DAILY', d.PROCESSED_DATE)" href="#"><i class="far fa-file-download"></i> {{d.RECEIPTS}} receipt<span v-if="d.RECEIPTS != 1">s</span></a>
                                    <a class="dropdown-item" v-if="d.REVERSALS > 0" v-on:click.prevent="getDocs('REVERSAL', d.PROCESSED_DATE)" href="#"><i class="far fa-file-download"></i> {{d.REVERSALS}} modification<span v-if="d.REVERSALS != 1">s</span></a>                                                
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="row m-1">
                        <div class="pl-0 col-6">Stock letters:</div>
                        <div class="col">{{parseInt(d.SECURITIES) + parseInt(d.SEC_REVERSAL)}}
                            <div class="dropdown float-end">
                                <button :id="'securities_'+y" :disabled="d.SECURITIES == 0 && d.SEC_REVERSAL == 0" type="button" class="btn btn-sm btn-danger dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Download
                                </button>
                                <div class="dropdown-menu" :aria-labelledby="'securities_'+y">                                    
                                    <a class="dropdown-item" v-if="d.SECURITIES > 0" v-on:click.prevent="getDocs('STOCK', d.PROCESSED_DATE)" href="#"><i class="far fa-file-download"></i> {{d.SECURITIES}} letter<span v-if="d.SECURITIES != 1">s</span></a>
                                    <a class="dropdown-item" v-if="d.SEC_REVERSAL > 0" v-on:click.prevent="getDocs('STOCK_REV', d.PROCESSED_DATE)" href="#"><i class="far fa-file-download"></i> {{d.SEC_REVERSAL}} modification<span v-if="d.SEC_REVERSAL != 1">s</span></a>                                                
                                </div>
                            </div> 
                        </div>                             
                    </div>
                    <div class="row m-1">
                        <div class="pl-0 col-6">IRA letters:</div>
                        <div class="col">{{parseInt(d.IRA) + parseInt(d.IRA_REVERSAL)}}
                            <div class="dropdown float-end">
                                <button :id="'ira_'+y" :disabled="d.IRA == 0 && d.IRA_REVERSAL == 0" type="button" class="btn btn-sm btn-warning dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Download
                                </button>
                                <div class="dropdown-menu" :aria-labelledby="'ira_'+y">                                    
                                    <a class="dropdown-item" v-if="d.IRA > 0" v-on:click.prevent="getDocs('IRA', d.PROCESSED_DATE)" href="#"><i class="far fa-file-download"></i> {{d.IRA}} letter<span v-if="d.IRA != 1">s</span></a>
                                    <a class="dropdown-item" v-if="d.IRA_REVERSAL > 0" v-on:click.prevent="getDocs('IRA_REV', d.PROCESSED_DATE)" href="#"><i class="far fa-file-download"></i> {{d.IRA_REVERSAL}} modification<span v-if="d.IRA_REVERSAL != 1">s</span></a>                                                
                                </div>
                            </div> 
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="pl-0 col-6">DAF letters:</div>
                        <div class="col">{{parseInt(d.DAF) + parseInt(d.DAF_REVERSAL)}}
                            <div class="dropdown float-end">
                                <button :id="'daf_'+y" :disabled="d.DAF == 0 && d.DAF_REVERSAL == 0" type="button" class="btn btn-sm btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Download
                                </button>
                                <div class="dropdown-menu" :aria-labelledby="'daf_'+y">                                    
                                    <a class="dropdown-item" v-if="d.DAF > 0" v-on:click.prevent="getDocs('DAF', d.PROCESSED_DATE)" href="#"><i class="far fa-file-download"></i> {{d.DAF}} letter<span v-if="d.DAF != 1">s</span></a>
                                    <a class="dropdown-item" v-if="d.DAF_REVERSAL > 0" v-on:click.prevent="getDocs('DAF_REV', d.PROCESSED_DATE)" href="#"><i class="far fa-file-download"></i> {{d.DAF_REVERSAL}} modification<span v-if="d.DAF_REVERSAL != 1">s</span></a>                                                
                                </div>
                            </div> 
                        </div>                    
                    </div>
                    
                </div>
            </div>
        </div>     
    </div>
    <div class="row pt-2">
        <div class="col-2">
            <button class="btn btn-primary" type="button" :disabled="pageNumber == 0 || $root.loading" v-on:click="prevPage()"><i class="fas fa-chevron-left"></i> Back</button>
        </div>
        <div class="col-8" style="text-align: center">
            <span v-if="pageCount">
                page {{pageNumber + 1}} of {{pageCount}}
            </span>
        </div>
        <div class="col">
            <button class="float-end btn btn-primary" type="button" :disabled="pageNumber == pageCount - 1 || !pageCount" v-on:click="nextPage()">Next <i class="fas fa-chevron-right"></i></button>
        </div>
    </div>   
        <!--<calendar v-if="events.length" :data="events"></calendar>     -->
        <date-filter></date-filter>
    </div>    
</template>
<script>
import { Modal } from 'bootstrap';
import calendar from './date/calendar.vue';
import dateFilter from './date/date.filter.vue';
export default {
    components: {
        calendar: calendar,
        dateFilter: dateFilter
    },
    data() {
        return {        
            events: this.$parent.events,            
            downloading: false,
            search: '',
		    size: 5,
            pageNumber: 0,
            startDate: '00000000',
            endDate: '99999999',
            date: false,
            modal: null
        }
    },
    methods: {
        dateFilterReset: function() {
            this.startDate = '00000000';
            this.endDate = '99999999';
            this.pageNumber = this.pageCount - 1;
        },
        dateFilterOpen: function() {
            this.modal.show();
            //$("#modalDateFilter").modal('show');
        },
        nextPage: function() {
            if (this.pageNumber < this.pageCount) {
                this.pageNumber++;
            }
        },
        prevPage: function() {
            if (this.pageNumber > 0) {
                this.pageNumber--;
            }
        },
        getDocs: function(event, date) {            
            if (this.downloading) {                
                return;
            }
            this.downloading = true;
            var data = {};
            var script = '';
            var filename = '';
            var _this = this;      
            var ereceipt = false;               
            switch (event) {
                case 'DAILY':
                    script = 'receipt.generate.php';
                    data = {
                        'processed_date': date,
                        'type': 'DAILY',
                        'reversal': 'N'
                    };
                    filename = 'gift_receipts_'+date;
                break;
                case 'REVERSAL':
                    script = 'receipt.generate.php';
                    data = {
                        'processed_date': date,
                        'type': 'DAILY',
                        'reversal': 'Y'
                    };
                    filename = 'gift_modifications_'+date;
                break;
                case 'STOCK':
                    script = 'stockLetter.generate.php';
                    data = {
                        'processed_date': date,
                        'type': 'DAILY',
                        'reversal': 'N'
                    };
                    filename = 'stock_letters_'+date;
                break;
                 case 'STOCK_REV':
                    script = 'stockLetter.generate.php';
                    data = {
                        'processed_date': date,
                        'type': 'DAILY',
                        'reversal': 'Y'
                    };
                    filename = 'stock_modifications_'+date;
                break;
                case 'IRA':
                    script = 'iraLetter.generate.php';
                    data = {
                        'processed_date': date,
                        'type': 'DAILY',
                        'reversal': 'N'
                    };
                    filename = 'IRA_letters_'+date;
                break;
                case 'IRA_REV':
                    script = 'iraLetter.generate.php';
                    data = {
                        'processed_date': date,
                        'type': 'DAILY',
                        'reversal': 'Y'
                    };
                    filename = 'IRA_modifications_'+date;
                break;
                case 'DAF':
                    script = 'dafLetter.generate.php';
                    data = {
                        'processed_date': date,
                        'type': 'DAILY',
                        'reversal': 'N'
                    };
                    filename = 'DAF_letters_'+date;
                break;
                case 'DAF_REV':
                    script = 'dafLetter.generate.php';
                    data = {
                        'processed_date': date,
                        'type': 'DAILY',
                        'reversal': 'Y'
                    };
                    filename = 'DAF_modifications_'+date;
                break;
                case 'ERECEIPT':
                    ereceipt = true;
                    this.$router.push({ name: 'ereceipt', params: { type: 'date', param: date } });                                        
                break;
                default: 
                    this.downloading = false;
                    this.$root.setAlert(true, "Invalid receipt type '"+event+"' specified", 'alert-danger');                    
                break;
            }
            if (!ereceipt) {
                this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/'+script, {
                    responseType: 'blob',
                    params: data
                }).then(response => {	
                    if (response.data.type == 'text/html') {
                        var d = new Blob([response.data]);
                        var r = new FileReader();
                        r.addEventListener('loadend', (e) => {
                            const err = e.target.result;
                            _this.$root.setAlert(true, err, 'alert-danger');
                        });
                        r.readAsText(d);                                        
                        _this.downloading = false;
                        return;
                    }                                        		
                    if (response.data.error) {
                        _this.$root.setAlert(true, response.data.error, 'alert-danger');
                        _this.downloading = false;
                        return;
                    } else {                       
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename+'.docx');
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        _this.downloading = false;			        
                    }
                }).catch(error => {
                    _this.$root.setAlert(true, error, 'alert-danger');
                    _this.downloading = false;
                    return;
                });
            }
        }
    },
    computed: {
        pageCount: function() {
            let l = this.filteredDocuments.length;
            let s = this.size;
            var c = Math.floor(l/s);
            if (l % s > 0) {
                c++;
            }					
            return c;
        },
        paginatedData: function() {            
            if (this.pageNumber > this.pageCount) {                
                this.pageNumber = 0;
            }
            const start = this.pageNumber * this.size;            
            const end = start + this.size;
            return this.filteredDocuments.slice(start, end);
        },
        filteredDocuments: function() {
            if (this.date) {
                return this.$root.data.filter(a => {
                    return a.PROCESSED_DATE == this.date;
                });
            } else {
                return this.$root.data.filter(a => {
                    return a.PROCESSED_DATE >= this.startDate && a.PROCESSED_DATE <= this.endDate;
                });
            }
        },
    },
    watch: {
        '$root.data.length': function(newVal, oldVal) {
            if (newVal > 0) {
                this.pageNumber = this.pageCount - 1;
            }
        }
    },
    mounted () {
        this.dateFilterReset();
        this.modal = new Modal(document.getElementById('modalDateFilter'));   
    }
}
</script>
<style>
.fc-basic-view .fc-body .fc-row {
    min-height: 8em;
}

.fc-day-grid-event .fc-content {
    padding: 2px 4px;
    cursor: pointer;
}

.downloading .fc-day-grid-event, .downloading .fc-day-grid-event:active, .downloading .fc-day-grid-event:hover {
    background-color: #CCC !important;
    color: #666  !important;
    border-color: #AAA  !important;
}

</style>
